module.exports = __webpack_public_path__ + "checkmark.96bd732333e722c910c6c4b33ed47fcf.png";